export default __webpack_public_path__ + "static/park-pedregal-amenidades-09-basket-21-473b466d5f9e20dbf8dc6875965749ad.jpg";